import React, {useCallback, useContext, useEffect, useState} from 'react';
import clsx from "clsx";
import {
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    DialogActions,
    Divider,
    Tooltip,
    Typography
} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useForm} from "react-hook-form";
import Grid from "@mui/material/Grid";
import CustomText from "../../../widgets/inputs/CustomText";
import CustomDateInput from "../../../widgets/inputs/CustomDateInput";
import {addStoricoPrenotazione, getAllAgende, updatePrenotazione} from "../../../../services/TamponiServices";
import {useHistory} from "react-router-dom";
import {AppContext} from "../../../../App";
import {setOpenSnackbar} from "../../../../services/AppServices";
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import { Alert, AlertTitle, Rating, Skeleton } from '@mui/material';
import moment from "moment";
import {amber, blue, indigo, purple, red} from "@mui/material/colors";
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutlineTwoTone';
import withStyles from '@mui/styles/withStyles';
import {useTheme} from "@mui/styles";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import {concludiDecorso} from "../../../../services/QuaranteneServices";

const PrenotazioneDetailCard = ({prenotazione, dispatch, state}) => {
    const classes = BaseStyle();
    let history = useHistory();
    let theme = useTheme();
    const appContext = useContext(AppContext);
    const {handleSubmit, control, errors, register, setError} = useForm({
        mode: "onChange",
        defaultValues: prenotazione
    });
    const [submit, setSubmit] = useState(false);
    const [submitAddStorico, setSubmitAddStorico] = useState(false);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState("");
    const [fasciaSelected, setFasciaSelected] = useState("");
    let fasce = new Array(12).fill(":00");

    const onSubmit = useCallback((data, stato = "Prenotazione conclusa") => {
        setSubmit(true)
        if (stato === "Note") {
            if (!data.note) {
                setError("note", {type: "focus", message: "Hey, inserisci qualcosa nelle note!"});
            } else {
                setSubmitAddStorico(true);
                addStoricoPrenotazione({
                    ...prenotazione, ...data,
                    active: false,
                    prenotazioneTamponeId: prenotazione.id
                }, dispatch);
            }
        } else if (stato === "Prenotazione annullata") {
            if (!data.note) {
                setError("note", {
                    type: "focus",
                    message: "Hey, inserisci qualcosa nelle note! Ad esempio perché vuoi annullare la prenotazione.."
                });
            } else {
                setSubmitAddStorico(true);
                addStoricoPrenotazione({
                    ...prenotazione, ...data,
                    stato: "Prenotazione annullata",
                    active: false,
                    prenotazioneTamponeId: prenotazione.id
                }, dispatch);
            }
        } else if (stato === "Concludi decorso") {
            if (!data.note) {
                setError("note", {
                    type: "focus",
                    message: "Hey, inserisci qualcosa nelle note! Ad esempio perché vuoi concludere la prenotazione e il decorso!"
                });
            } else {
                setSubmitAddStorico(true);
                concludiDecorso(dispatch, {
                    ...prenotazione, ...data,
                    stato: "Prenotazione annullata",
                    active: false,
                    prenotazioneTamponeId: prenotazione.id
                });
            }
        } else {
            updatePrenotazione({
                ...prenotazione, ...data,
                agendaId: selected?.id,
                nfascia: fasciaSelected,
                stato: stato,
                active: false,
            }, dispatch)
        }
    }, [prenotazione, dispatch, selected, fasciaSelected, setError])

    useEffect(() => {
        if (submit && !state.loadingUpdatePrenotazione && state.errorUpdatePrenotazione === "") {
            setSubmit(false);
            setOpenSnackbar("success", "Prenotazione avvenuta con successo", appContext.dispatch);
            history.goBack();
        } else if (submit && !state.loadingUpdatePrenotazione && state.errorUpdatePrenotazione !== "") {
            setSubmit(false);
            setOpenSnackbar("error", state.errorUpdatePrenotazione, appContext.dispatch);
        }
    }, [state, history, submit, state.loadingUpdatePrenotazione, state.errorUpdatePrenotazione, appContext.dispatch])

    useEffect(() => {
        if (submitAddStorico && !state.loadingAddStorico && state.errorAddStorico === "") {
            setSubmitAddStorico(false);
            setOpenSnackbar("success", "Modifica avvenuta con successo", appContext.dispatch);
            history.goBack();
        } else if (submitAddStorico && !state.loadingAddStorico && state.errorAddStorico !== "") {
            setSubmitAddStorico(false);
            setOpenSnackbar("error", state.errorAddStorico, appContext.dispatch);
        }
    }, [submitAddStorico, state.loadingAddStorico, state.errorAddStorico, appContext.dispatch, history])

    useEffect(() => {
        getAllAgende({enable: true}, dispatch);
    }, [dispatch])

    return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)}
                  style={{height: "100%", display: "flex", flexDirection: "column"}}>
                <CardHeader
                    title={<Typography
                        variant={"h6"}><b>Dettaglio della prenotazione</b></Typography>}
                />
                <CardContent style={{flexGrow: 1}}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography
                                    style={{backgroundColor: purple[500], borderRadius: 24, padding: 6, color: "#FFF"}}
                                    align={"center"}>
                                    <b>{prenotazione.stato}</b>
                                    {
                                        prenotazione.dataEffettiva && <React.Fragment>
                                            <br/>
                                            Prenotazione
                                            al {moment(prenotazione.dataEffettiva).format("DD/MM/YYYY")} alle {(prenotazione.nfascia + 7) + ":00 - " + (prenotazione.nfascia + 8) + ":00 - "} in {prenotazione.luogo}
                                        </React.Fragment>
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CustomDateInput
                                    name={"dataRichiesta"}
                                    label={"Data richiesta"}
                                    control={control}
                                    defaultValue={null}
                                    rules={{required: true}}
                                    error={errors["dataRichiesta"]}
                                />
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <CustomText
                                    control={control}
                                    rules={{required: true}}
                                    name={"luogo"}
                                    label={"Luogo prenotazione"}
                                    autoFocus={false}
                                    type={"text"}
                                    error={errors["luogo"]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomMultiText
                                    inputRef={register({required: false})}
                                    name={"note"}
                                    label={"Note"}
                                    autoFocus={false}
                                    error={errors["note"]}
                                    rows={5}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
                <CardActions className={classes.flexRight}>
                    <Tooltip title={"Aggiungi note"}>
                        <Button variant={"text"} size={"small"} className={classes.roundButton}
                                style={{borderRadius: 24}}
                                disableElevation onClick={handleSubmit(data => onSubmit(data, "Note"))}>
                            <b>Aggiungi note</b>
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Aggiorna / modifica le informazioni della prenotazione"}>
                        <Button variant={"contained"} size={"small"} color={"primary"} className={classes.roundButton}
                                style={{borderRadius: 24}}
                                disableElevation onClick={() => setOpen(!open)}>
                            <b>Prenota tampone</b>
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Annulla la prenotazione"}>
                        <Button variant={"contained"} size={"small"} color={"primary"} className={classes.roundButton}
                                style={{borderRadius: 24}}
                                disableElevation
                                onClick={handleSubmit(data => onSubmit(data, "Prenotazione annullata"))}>
                            <b>Annulla la prenotazione</b>
                        </Button>
                    </Tooltip>
                    <Tooltip title={"Concludi decorso"}>
                        <Button variant={"contained"} size={"small"} color={"secondary"} className={classes.roundButton}
                                style={{borderRadius: 24}}
                                disableElevation onClick={handleSubmit(data => onSubmit(data, "Concludi decorso"))}>
                            <b>Concludi decorso</b>
                        </Button>
                    </Tooltip>
                    {prenotazione.stato === "Prenotazione conclusa" &&
                        <React.Fragment>
                            <Tooltip title={"Modifica la prenotazione, sposta l'appuntamento"}>
                                <Button variant={"contained"} size={"small"} color={"primary"}
                                        className={classes.roundButton}
                                        style={{borderRadius: 24}}
                                        disableElevation onClick={() => setOpen(!open)}>
                                    <b>Modifica la prenotazione</b>
                                </Button>
                            </Tooltip>
                        </React.Fragment>}
                </CardActions>
            </Card>
            {
                open &&
                <SimpleDialog
                    open={open}
                    handleClose={() => setOpen(!open)}
                    maxWidth={"xl"}
                    title={"Prenotazione tampone"}
                    content={
                        <React.Fragment>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography className={classes.heading}><b><span
                                        style={{fontSize: 26, color: theme.palette.primary.main}}>1. </span> Scegli la
                                        data
                                    </b><br/>
                                        <span style={{color: theme.palette.text.secondary}}>Scegli tra le alternative la data per cui vuoi prenotare un tampone. In caso non siano presenti posti puoi aggiungerli dalla sezione precedente</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} className={classes.flexStart}>
                                    {
                                        state.loadingGetAllAgende ?
                                            <Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
                                                <CardHeader
                                                    avatar={<Skeleton variant="circular" height={40} width={40}/>}
                                                    title={<Skeleton width={180}/>}
                                                    subheader={<Skeleton width={260}/>}
                                                    action={<Skeleton variant="circular" height={20} width={20}/>}
                                                    style={{paddingBottom: 2}}
                                                />
                                                <CardContent style={{paddingTop: 0, marginTop: -35}}>
                                                    <Skeleton height={200}/>
                                                </CardContent>
                                            </Card> : state.errorGetAllAgende !== "" ?
                                                <Alert severity="error" style={{borderRadius: 24}}>
                                                    <AlertTitle>Errore</AlertTitle>
                                                    Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore
                                                    persiste contatta gli
                                                    sviluppatori.
                                                </Alert> :
                                                state.agende.length === 0 ? "Non ci sono agende..." :
                                                    state.agende.map((agenda, index) => {
                                                        return (
                                                            <Card key={index}
                                                                  className={clsx(classes.roundBorder, classes.margin1)}
                                                                  style={{
                                                                      width: 200,
                                                                      backgroundColor: selected.id === agenda.id ? indigo["A700"] : "",
                                                                      color: selected.id === agenda.id ? "#FFF" : ""
                                                                  }}>
                                                                <CardActionArea onClick={() => setSelected(agenda)}>
                                                                    <CardHeader
                                                                        title={
                                                                            <Typography><b>{moment(agenda.data).format("DD/MM/YYYY")}</b></Typography>}
                                                                        subheader={<Typography>{agenda.luogo}<br/><span
                                                                            style={{
                                                                                fontSize: 14,
                                                                                marginTop: -4,
                                                                                backgroundColor: agenda.tipo === "molecolare" ? blue[600] : red[600],
                                                                                color: "#FFF",
                                                                                padding: 4,
                                                                                borderRadius: 24
                                                                            }}>{agenda.tipo}</span></Typography>}
                                                                    />
                                                                    <CardContent>
                                                                        <Chip style={{
                                                                            fontSize: 20,
                                                                            backgroundColor: amber[500],
                                                                            width: 160
                                                                        }}
                                                                              label={
                                                                                  <React.Fragment>
                                                                                      <b>{agenda["postiR"]}</b> / {agenda["postiI"]}
                                                                                  </React.Fragment>
                                                                              }/>
                                                                    </CardContent>
                                                                </CardActionArea>
                                                            </Card>
                                                        )
                                                    })
                                    }
                                </Grid>
                                {selected !== "" && <Grid item xs={12}>
                                    <Typography className={classes.heading}><b><span
                                        style={{fontSize: 26, color: theme.palette.primary.main}}>2. </span> Ottimo!,
                                        ora passiamo alla
                                        scelta della fascia oraria
                                    </b><br/>
                                        <span style={{color: theme.palette.text.secondary}}>Scegli tra le alternative la fascia oraria per cui vuoi prenotare un tampone. In caso non siano presenti posti puoi aggiungerli dalla sezione precedente</span>
                                    </Typography>
                                </Grid>}
                                {
                                    selected !== "" &&
                                    <Grid item xs={12} className={classes.flexStart}>
                                        {
                                            fasce.map((fascia, index) => {
                                                return (
                                                    <Card key={index}
                                                          className={clsx(classes.roundBorder, classes.margin1)}
                                                          style={{
                                                              width: 220,
                                                              backgroundColor: fasciaSelected === (index + 1) ? indigo["A700"] : "",
                                                              color: fasciaSelected === (index + 1) ? "#FFF" : ""
                                                          }}>
                                                        <CardActionArea
                                                            onClick={() => setFasciaSelected((index + 1))}
                                                            disabled={selected["fascia" + (index + 1) + "R"] <= 0}
                                                        >
                                                            <CardContent style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center"
                                                            }}>
                                                                <Typography align={"center"}>
                                                                    <b>{" " + (index + 8) + fascia + " - " + (index + 9) + fascia}</b>
                                                                </Typography>
                                                                <Typography align={"center"} style={{
                                                                    paddingTop: 10,
                                                                    paddingBottom: 4
                                                                }}>Disponibili: <b>{selected["fascia" + (index + 1) + "R"]}</b> posti</Typography>
                                                                <StyledRating
                                                                    readOnly
                                                                    defaultValue={
                                                                        5 - (5 * (selected["fascia" + (index + 1) + "R"]) / (selected["fascia" + (index + 1) + "I"]))
                                                                    }
                                                                    precision={0.5}
                                                                    icon={<PersonOutlineTwoToneIcon
                                                                        fontSize="inherit"/>}
                                                                />
                                                                {
                                                                    selected["fascia" + (index + 1) + "Tag"] &&
                                                                    <Chip
                                                                        label={selected["fascia" + (index + 1) + "Tag"]}/>
                                                                }
                                                            </CardContent>
                                                        </CardActionArea>
                                                    </Card>
                                                )
                                            })
                                        }
                                    </Grid>
                                }
                            </Grid>
                        </React.Fragment>
                    }
                    actions={
                        <DialogActions>
                            <Tooltip title={"Verifica che ci sia disponibilità e riserva un posto al paziente"}>
                                <Button variant={"contained"} size={"small"} color={"primary"}
                                        className={classes.roundButton}
                                        style={{borderRadius: 24}} disabled={fasciaSelected === ""}
                                        disableElevation
                                        onClick={handleSubmit((data) => onSubmit(data, "Prenotazione conclusa"))}>
                                    <b>Conferma prenotazione</b>
                                </Button>
                            </Tooltip>
                        </DialogActions>
                    }
                />
            }
        </React.Fragment>
    );
};

const StyledRating = withStyles(
    {
        iconFilled: {
            color: '#ff6d75',
        }
        ,
        iconHover: {
            color: '#ff3d47',
        }
        ,
    }
)(Rating);

export default React.memo(PrenotazioneDetailCard)
